import { render } from "./DeleteMultipleEmployees.vue?vue&type=template&id=8722c01e"
import script from "./DeleteMultipleEmployees.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleEmployees.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__